import script from "./ErrorLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorLabel.vue?vue&type=script&setup=true&lang=js"

import "./ErrorLabel.vue?vue&type=style&index=0&id=2f3b4ccb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3b4ccb"]])

export default __exports__